import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import Header from "../../components/header";
import LoadingCard from "./cards/loading-card";
import LoadingErrorCard from "./cards/loading-error-card";
import Contexts from "./contexts";

function ContextPage() {
  return (
    <>
      <Header />
      <main className="mx-auto grid max-w-xl gap-6 p-6">
        <ErrorBoundary fallback={<LoadingErrorCard />}>
          <Suspense fallback={<LoadingCard />}>
            <Contexts />
          </Suspense>
        </ErrorBoundary>
      </main>
    </>
  );
}

export default ContextPage;
